export enum AnnouncementStatusEnum {
  Active = 1,
  Suspended = 2,
  Draft = 3,
  Expired = 4
}
